import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { BackendDataShape, UsedAPI } from "api/config";
import CookieMonster from "api/CookieMonster";

import { convertToEncodedURL } from "assets/usefulFunctions";

import { INotification } from "types/endpoints/notification";

export const notificationStoreAPI = createApi({
  reducerPath: "notificationAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: `${UsedAPI}/notifications`,
    prepareHeaders: (headers) => {
      let token = CookieMonster.loadCookie("jwt");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["NotificationList"],
  endpoints: (builder) => {
    return {
      getListNotification: builder.query<
        INotification[],
        Partial<INotification>
      >({
        query: (obj) => {
          let params = "";
          if (obj) {
            params = convertToEncodedURL(obj);
            params = params.length ? "?" + params : "";
          }
          const url = "/" + params;
          return {
            url,
            method: "GET",
          };
        },
        transformResponse: (response: BackendDataShape<INotification[]>) =>
          response.data,
        providesTags: ["NotificationList"],
      }),
    };
  },
});

export const {
  useGetListNotificationQuery,
  util: { resetApiState: resetNotificationAPI },
} = notificationStoreAPI;
